var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isFirstLoading
    ? _c(
        "div",
        { staticStyle: { height: "480px" } },
        [_c("preloader", { attrs: { display: true } })],
        1
      )
    : _c("div", [
        _vm.notifications.length > 0
          ? _c("div", [
              _c(
                "div",
                { staticClass: "notification-list-header" },
                [
                  _c("h6", { staticClass: "m-0 gray-60" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.upperCase(
                          _vm.$l10n.__("Les plus récentes")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.canMarkAllAsRead
                    ? _c("CompassLink", {
                        attrs: {
                          label: _vm.$t.__(
                            "notifications.NotificationsList.mark_all_as_read"
                          ),
                          type: "secondary",
                          size: "small"
                        },
                        on: { click: _vm.markAllAsRead }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "notification-list-container",
                  on: { scroll: _vm.onScroll }
                },
                [
                  _vm._l(_vm.notifications, function(notif) {
                    return _c("notifications-item", {
                      key: notif.notifId,
                      attrs: { item: notif },
                      on: { delete: _vm.deleteNotification }
                    })
                  }),
                  _vm._v(" "),
                  _vm.isLoadingMore
                    ? _c(
                        "div",
                        [_c("preloader", { attrs: { display: true } })],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.noMore
                    ? _c("div", { staticClass: "no-more-container" }, [
                        _c("div", { staticClass: "acenter no-more-content" }, [
                          _c("img", {
                            attrs: {
                              src:
                                "/ressources/logged/img/notifications/no-results.svg",
                              alt: "",
                              width: "88",
                              height: "88"
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "gray-60 fs-3 mt-0" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Vous n'avez pas d'autres notifications"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          : _c("div", { staticClass: "acenter notification-no-result" }, [
              _c("img", {
                attrs: {
                  src: "/ressources/logged/img/notifications/no-results.svg",
                  alt: "",
                  width: "184",
                  height: "184"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "notification-no-result__text" }, [
                _c("h4", { staticClass: "gray-100 fs-4 mt-5" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Vous n'avez pas de notifications")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "gray-60 semibold mt-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Voici l'endroit où vous recevrez vos notifications en temps réel chaque fois que quelqu'un vous @mentionne"
                        )
                      ) +
                      "\n            "
                  )
                ])
              ])
            ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }